import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import { useConfirmationDialog, ShowModalOutput } from '@cast/design-system';
import { Cluster } from '@cast/types';
import { isManagedByTerraform } from '@cast/utils';

import { FeatureName, FeatureSelection } from 'hooks/dialogs/cluster/types';

import { ConnectClusterDialog } from '../components/ConnectClusterDialog';

import { getTerraformGuidanceDialogProps } from './_components/TerraformGuidanceDialog';

type HookOptions = {
  shouldNavigateOnSuccess?: boolean;
  onSuccess?: (features: FeatureSelection) => void;
};

type OpenArgs = {
  cluster: Cluster;
  productName?: FeatureName;
};

export const useAssignCredentialsDialogV2 = ({
  shouldNavigateOnSuccess,
  onSuccess,
}: HookOptions = {}) => {
  const modalRef = useRef<ShowModalOutput>(undefined);
  const { showModal } = useModal();
  const { openDialog: openTerraformGuidanceDialog } = useConfirmationDialog();

  const destroy = () => modalRef.current?.destroy();

  const openAssignCredentialsDialog = ({ cluster, productName }: OpenArgs) => {
    if (!cluster) {
      return;
    }

    if (isManagedByTerraform(cluster.managedBy)) {
      openTerraformGuidanceDialog(getTerraformGuidanceDialogProps());
      return;
    }

    modalRef.current = showModal(
      ConnectClusterDialog,
      {
        cluster,
        promotedFeature: productName,
        skipConnectionMonitoring: true,
        shouldNavigateOnSuccess,
        onSuccess,
        onClose: destroy,
      },
      { rootId: 'root' }
    );
  };

  return {
    openAssignCredentialsDialog,
  };
};
